import PropTypes from 'prop-types'
import React from 'react'
import ClassNamesService from '../../../services/ClassNamesService'

const AdditionalHead = ({ children, className = null }) => (
  <>
    {React.cloneElement(children, {
      className: ClassNamesService.execute(['head-cell--is-additional', className]),
    })}
  </>
)

AdditionalHead.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, () => null]),
}

export default AdditionalHead
